export default __webpack_public_path__ + "static/media/BallaGame.79b8424d.webp";